export default "__VITE_ASSET__uDXm9rJd__"